import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/InsightPage";
import { parseRoute } from "@/functions/parseRoute";
import BlogPostingSchema from "@/ui/BlogPostingSchema";
import { useLink } from "@/hooks/useLink";
import { useLocale } from "@/hooks/useLocale";
import { trimText } from "@/functions/trimText";
import { format } from "date-fns";
import sourceflowEnums from "@/sourceflow.enums";
import { insights_helper } from "@/helpers/insights_helper";

export default function Page({ content, item }) {
  const locale = useLocale();
  const link = useLink();

  return (
    <>
      <BlogPostingSchema
        title={item[`title_${locale}`]}
        url={link("blog.item", item.url_slug)}
        description={trimText(item[`text_${locale}`], 155)}
        image={item.image}
        author={item.author}
        datePublished={format(new Date(item.published), "yyyy-MM-dd")}
        dateModified={format(new Date(item.updated_at), "yyyy-MM-dd")}
        publisherName={sourceflowEnums.config.siteName}
        publisherLogo={sourceflowEnums.config.socialLogo}
      />
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const item = insights_helper.find(url_slug);

  const routerKey = "blog.item";
  const routerProp = parseRoute(routerKey, { url_slug });

  return {
    props: {
      meta: {
        en: {
          title: item["title_en"],
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
          images: [{ url: item?.image ?? sourceflowEnums.config.socialLogo }],
          description: trimText(item[`text_en`], 155),
          titleTemplate: "",
        },
      },
      item,
      router: routerProp,
      content: [
        { component: "InsightPageBannerSection", props: { item } },
        { component: "InsightPageContentSection", props: { item } },
        { component: "InsightPageRelatedSection", props: { item } },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: insights_helper.toPaths(),
    fallback: false,
  };
}
